import React, { useContext } from "react";
import Text from "@amzn/meridian/text";
import { FormattedMessage } from "react-intl";
import { getDocumentURL } from "../handler/ParentDataHandler";
import Tooltip from "@amzn/meridian/tooltip";
import Link from "@amzn/meridian/link";
import Column from "@amzn/meridian/column";
import { AR_V2 } from "./util/Constants";
import { CapabilityContext } from "../overview/context/CapabilityContext";
import Responsive from "@amzn/meridian/responsive";
import { SMALL } from "../common/constant/BreakPoints";

const ActionableMetricView = (props) => {
  const { capability } = useContext(CapabilityContext);
  // TODO:revamp change url path here for ARv2 to outboundARV2
  const pageName = capability.data === AR_V2 ? "outbound" : "outboundAMZL";

  const onMetricCountClick = () => {
    getDocumentURL().then((result) => {
      //const result = "https://logistics-preprod.amazon.com/station/dashboard/outboundAMZL";
      const url = new URL(result.replace(pageName, props.data.targetTab));
      if (props.data.uri && props.data.targetTab !== "stow") {
        const shareableLink = `/${props.data.targetTab}/${props.data.uri}`;
        url.searchParams.set("shareableLink", shareableLink);
      } else if (props.data.uri && props.data.targetTab === "stow") {
        const shareableLink = `heatMap/${props.data.uri}`;
        url.searchParams.set("shareableLink", shareableLink);
      }
      window.open(url.href, "_parent");
    });
  };

  return (
    <Responsive
      query="max-width"
      props={{
        headerFontScale: {
          default: "h100",
          [SMALL]: "b100",
        },
        numberFontScale: {
          default: "d50",
          [SMALL]: "d50",
        },
      }}
    >
      {({ headerFontScale, numberFontScale }) => (
        <Column spacing="small">
          <Text type={headerFontScale}>
            <Tooltip position="right" title={props.data.tooltip}>
              <b>
                <FormattedMessage
                  id={props.data.title}
                  defaultMessage={props.data.message}
                />
              </b>
            </Tooltip>
          </Text>
          <Text type={numberFontScale} className={props.data.textColor}>
            <Link type={"secondary"} onClick={onMetricCountClick}>
              {props.data.value}
            </Link>
          </Text>
        </Column>
      )}
    </Responsive>
  );
};

export default ActionableMetricView;



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/ActionableMetricView.js